import {Card as MantineCard, CardProps as MantineCardProps} from "@mantine/core";
import {PropsWithChildren} from "react";

export type CardProps = Omit<MantineCardProps, 'children'> & {
  // extended props here
}

export const Card = (props: PropsWithChildren<CardProps>) => {
  const {children, ...rest} = props
  return (
    <MantineCard {...rest}>
      {children}
    </MantineCard>
  )
}

Card.Section = MantineCard.Section
